import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';

import logo from './img/logo.svg';
import linkedin from './img/linkedin.svg';
import instagram from './img/insta.svg';
import iconSite from './img/icon-site.svg';
import iconPresta from './img/icon-prestations.svg';
import iconOffres from './img/icon-offres.svg';
import iconRef from './img/icon-references.svg';
import iconCall from './img/icon-call.svg';
import iconCalendar from './img/icon-calendly.svg';
import CalendlyButton from './components/calendlyButton';
import IconButton from './components/button';

import OffersPage from './pages/offersPage.jsx';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div className='flex items-center flex-col homepage container'>
            <div className='logo'>
              <img src={logo} alt='logo Expert SA'/>
            </div>
            <h1 className='text-chocolate'>L’agence de com’ <span className='text-green'>créative</span> et digitale <span>des experts&#8209;comptables</span></h1>
            <div className='grid-btn'>
              <div>
                <IconButton label="Notre site internet !" url={'https://www.expertsa.fr/'} icon={iconSite} />
                <IconButton label="Nos prestations" url={'https://www.expertsa.fr/communication-experts-comptables'} icon={iconPresta}/>
                <Link to="/offers" className='' icon={iconOffres}>
                  <div className='btnesa'>
                    <img src={iconOffres} alt="Icône offres" width="48" height="48" />
                    <h2 className='h3-footer text-chocolate-60'>Nos offres du moment</h2>
                  </div>
                </Link>
                <IconButton label="Nos références" url={'https://www.expertsa.fr/nos-realisations-pour-experts-comptables'} icon={iconRef} />
              </div>
              <div>
                <IconButton label="Je vous appelle !" className='btn-green btn-icon-right' url={'tel:+33175435390'} icon={iconCall} />
                <CalendlyButton icon={iconCalendar} alt='Icône calendrier' />
              </div>
            </div>




            <div className='icon-social-network'>
              <a href='https://www.linkedin.com/company/expert-sa/' target='_blank' rel='noopener noreferrer'>
                <img src={linkedin} alt='logo LinkedIn'/>
              </a>
              <a href='https://www.instagram.com/expert_sa/?hl=fr' target='_blank' rel='noopener noreferrer'>
                <img src={instagram} alt='logo Instagram'/>
              </a>
            </div>
          </div>
        } />
        <Route path="/offers" element={<OffersPage />} />
      </Routes>
    </Router>
  );
}

export default App;
